import * as atypes from 'common/settings/SettingsReduxActionTypes'
import * as API from 'constants/API'

export const fetchBotSettings = () => {
  return (dispatch, getState) => {
    const state = getState()
    if (state.botSettings.admins.fetching || state.botSettings.admins.ready) {
      return
    }

    dispatch({
      type: atypes.BOT_SETTINGS_FETCH,
      $fetch: API.fetchBotSettings,
    })
  }
}
